import api from './api';

export const partnerService = {
  getPublicPartners: () => api.get('/partners'),
  getAllPartnersAdmin: () => api.get('/partners/admin/all'),
  createPartner: (data) => api.post('/partners', data),
  updatePartner: (id, data) => api.put(`/partners/${id}`, data),
  deletePartner: (id) => api.delete(`/partners/${id}`)
};
